import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { PlusIcon, FileDownIcon, FilterIcon } from 'lucide-react';
import TicketTabs from '../components/tickets/TicketTabs';
import TicketsGroupTab from '../components/tickets/TicketsGroupTab';
import TicketsTab from '../components/tickets/TicketsTab';
const TicketsList = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'groups';
  const [showFilters, setShowFilters] = useState(false);
  const navigate = useNavigate();
  const handleTabChange = (tab: string) => {
    navigate(`/tickets?tab=${tab}`);
  };
  const handleToggleFilters = () => {
    setShowFilters(!showFilters);
  };
  return <div className="space-y-6" data-id="element-1855">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1856">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1857">Tickets Management</h1>
        <div className="flex flex-wrap gap-2" data-id="element-1858">
          <Link to="/create-group" className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" aria-label="Create new ticket group" data-id="element-1859">
            <PlusIcon className="h-5 w-5 mr-1" data-id="element-1860" />
            <span data-id="element-1861">New Ticket Group</span>
          </Link>
          <button className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" aria-label="Export ticket data" data-id="element-1862">
            <FileDownIcon className="h-5 w-5 mr-1" data-id="element-1863" />
            <span data-id="element-1864">Export</span>
          </button>
          <button className={`inline-flex items-center px-4 py-2 border ${showFilters ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-300 text-gray-700'} rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`} onClick={handleToggleFilters} aria-expanded={showFilters} aria-controls="filter-panel" aria-label="Toggle filters" data-id="element-1865">
            <FilterIcon className="h-5 w-5 mr-1" data-id="element-1866" />
            <span data-id="element-1867">Filter</span>
          </button>
        </div>
      </div>
      <TicketTabs activeTab={activeTab} onTabChange={handleTabChange} data-id="element-1868" />
      {activeTab === 'groups' && <TicketsGroupTab showFilters={showFilters} onToggleFilters={handleToggleFilters} data-id="element-1869" />}
      {activeTab === 'tickets' && <TicketsTab showFilters={showFilters} onToggleFilters={handleToggleFilters} data-id="element-1870" />}
    </div>;
};
export default TicketsList;